export const track = (event, params = {}) => {
  try {
    if (window.gtag) window.gtag("event", event, params);
  } catch (e) {}
};
